import React from 'react';
import {
  NavLink,
  Link,
} from 'react-router-dom';
import Box from '@material-ui/core/Box';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { styles } from './style';
import './style.scss';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import WavesIcon from '@material-ui/icons/Waves';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import OpacityIcon from '@material-ui/icons/Opacity';
import { useContext } from 'react';
import UserContext from '../../context/UserContext';

// icon
import {
  WaterLevelIcon, RadarIcon, RainIcon, DamIcon, QualityIcon, WaveIcon, RainfallIcon,
  StormIcon, AlertIcon, UrgentIcon, FloodIcon
} from '../../assets/svg/Icon';
import { color } from 'highcharts';

const initPath = `/${process.env.REACT_APP_PATH}`;
const withLink = (to, children) => <Link to={to}>{children}</Link>;

const actions = [
  { icon: withLink(`${initPath}infographic-basin-situation`, <UrgentIcon className="iconSvg" />), name: 'อินโฟกราฟิกติดตามสถานการณ์ลุ่มน้ำ' },
  { icon: withLink(`${initPath}wave`, <WaveIcon className="iconSvg" />), name: 'คาดการณ์คลื่น' },
  { icon: withLink(`${initPath}forecast/rainfall`, <RainfallIcon className="iconSvg" />), name: 'คาดการณ์ฝน' },
  { icon: withLink(`${initPath}radar`, <RadarIcon className="iconSvg" />), name: 'เรดาร์' },
  { icon: withLink(`${initPath}storm`, <StormIcon className="iconSvg" />), name: 'พายุ' },
  { icon: withLink(`${initPath}risk`, <AlertIcon className="iconSvg" />), name: 'เตือนภัยน้ำหลากดินถล่ม (EWS)' },
  { icon: withLink(`${initPath}waterquality`, <QualityIcon className="iconSvg" />), name: 'คุณภาพน้ำ' },
  { icon: withLink(`${initPath}dam`, <DamIcon className="iconSvg" />), name: 'อ่างเก็บน้ำ' },
  { icon: withLink(`${initPath}waterlevel`, <WaterLevelIcon className="iconSvg" />), name: 'ระดับน้ำ' },
  { icon: withLink(`${initPath}rainfall`, <RainIcon className="iconSvg" />), name: 'ฝน' },
  // { icon: withLink(`${initPath}storm_surge`, <NotificationsActiveIcon style={{ color: '#FFCC80' }} />), name: 'ระบบคาดการณ์ระดับน้ำทะเลล่วงหน้า 7 วัน',},
  // { icon: withLink(`${initPath}floodforecast`, <WavesIcon style={{ color: '#FFCC80' }} />), name: 'ระบบคาดการณ์ปริมาณน้ำ-ระดับน้ำในแม่น้ำสายหลัก',},
  // { icon: withLink(`${initPath}flashflood`, <ReportProblemIcon style={{ color: '#FFCC80' }} />), name: 'ระบบเตือนภัยน้ำท่วมฉับพลัน', requireLogin: true,},
  // { icon: withLink(`${initPath}RainfallRunoffInundation`, <OpacityIcon style={{ color: '#FFCC80' }} />), name: 'ระบบคาดการณ์น้ำท่าด้วยแบบจำลอง RRI',},
];

const useStyles = makeStyles(styles);

export default function Sidebar() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [hidden] = React.useState(false);
  const { userIsLogin } = useContext(UserContext);
  const visibleActions = actions.filter(a => !a.requireLogin || userIsLogin);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const matches = useMediaQuery('(width:667px)');

  return (
    <>
      <Hidden smDown>
        <Box className="sidebar" justifyContent="center" alignItems="center">
          <Box className="sidebar-top" />
          <Box className="sidebar-body">
            <Box>
              <Tooltip title={t('ฝน 24 ชม.')} placement="right">
                <NavLink to={`${initPath}rainfall`} activeClassName="sidebar-active" className="sidebar-item"><RainIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('ระดับน้ำ')} placement="right">
                <NavLink id="sidebar-waterlevel" to={`${initPath}waterlevel`} activeClassName="sidebar-active" className="sidebar-item"><WaterLevelIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('แหล่งน้ำ')} placement="right">
                <NavLink to={`${initPath}dam`} activeClassName="sidebar-active" className="sidebar-item"><DamIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('คุณภาพน้ำ')} placement="right">
                <NavLink id="sidebar-waterquality" to={`${initPath}waterquality`} activeClassName="sidebar-active" className="sidebar-item"><QualityIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            {/* <Box>
              <Tooltip title={t('พื้นที่ประกาศภัย')} placement="right">
                <NavLink id="sidebar-risk" to={`${initPath}risk`} activeClassName="sidebar-active" className="sidebar-item"><AlertIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box> */}
            <Box>
              <Tooltip title={t('พายุ')} placement="right">
                <NavLink to={`${initPath}storm`} activeClassName="sidebar-active" className="sidebar-item"><StormIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('เรดาร์')} placement="right">
                <NavLink to={`${initPath}radar`} activeClassName="sidebar-active" className="sidebar-item"><RadarIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('คาดการณ์ฝน')} placement="right">
                <NavLink to={`${initPath}forecast/rainfall`} activeClassName="sidebar-active" className="sidebar-item"><RainfallIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('คาดการณ์คลื่น')} placement="right">
                <NavLink to={`${initPath}wave`} activeClassName="sidebar-active" className="sidebar-item"><WaveIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('อินโฟกราฟิกติดตามสถานการณ์ลุ่มน้ำ')} placement="right">
                <NavLink to={`${initPath}infographic-basin-situation`} activeClassName="sidebar-active" className="sidebar-item"><UrgentIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            {/* <Divider style={{ backgroundColor: 'rgb(255, 255, 255)', margin: '4px 8px', marginBottom: '4px' }} />
            <Box>
              <Tooltip title={t('ระบบคาดการณ์ระดับน้ำทะเลล่วงหน้า 7 วัน')} placement="right">
                <NavLink
                    to={`${initPath}storm_surge`}
                    activeClassName="sidebar-active"
                    className="sidebar-item"
                  >
                    <NotificationsActiveIcon fontSize="small" style={{color: "#FFCC80"}}/>
                </NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('ระบบคาดการณ์ปริมาณน้ำ-ระดับน้ำในแม่น้ำสายหลัก')} placement="right">
                <NavLink
                    to={`${initPath}floodforecast`}
                    activeClassName="sidebar-active"
                    className="sidebar-item"
                  >
                    <WavesIcon fontSize="small" style={{color: "#FFCC80"}} />
                </NavLink>
              </Tooltip>
            </Box>
            {userIsLogin && (
            <Box>
              <Tooltip title={t('ระบบเตือนภัยน้ำท่วมฉับพลัน')} placement="right">
                <NavLink
                    to={`${initPath}flashflood`}
                    activeClassName="sidebar-active"
                    className="sidebar-item"
                  >
                    <ReportProblemIcon fontSize="small" style={{color: "#FFCC80"}} />
                </NavLink>
              </Tooltip>
            </Box>
            )}
            <Box>
              <Tooltip title={t('ระบบคาดการณ์น้ำท่าด้วยแบบจำลอง RRI')} placement="right">
                <NavLink
                  to={`${initPath}RainfallRunoffInundation`}
                  activeClassName="sidebar-active"
                  className="sidebar-item"
                >
                  <OpacityIcon fontSize="small" style={{color: "#FFCC80"}} />
                </NavLink>
              </Tooltip>
            </Box> */}
          </Box>
          <Box className="sidebar-bottom" />
        </Box>
      </Hidden>
      <Hidden mdUp>
        <div className={classes.speedDialMoblie}>
          <SpeedDial
            ariaLabel="SpeedDial openIcon example"
            className={classes.speedDial}
            hidden={hidden}
            icon={<VisibilityIcon />}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction={matches ? 'left' : 'up'}
          >
            {visibleActions.map((action) => (
              <SpeedDialAction
                key={action.name}
                icon={action.icon}
                tooltipTitle={action.name}
                onClick={handleClose}
                className={classes.action}
              />
            ))}
          </SpeedDial>
        </div>
      </Hidden>
    </>
  );
}
